import React, { useEffect, useRef } from 'react';

import { useResizeObserver } from '../components/DeviceFrame';

const ResizeObserverWrapper = ({ children, className, style, onResize }) => {
  const ref = useRef<HTMLDivElement>(null);
  const dimensions = useResizeObserver(ref);

  useEffect(() => {
    if (onResize)
      onResize(dimensions); // Call the callback with the new dimensions
  }, [dimensions, onResize]); // Run effect when dimensions change

  return (
    <div ref={ref} className={className} style={style}>
      {React.cloneElement(children, { dimensions })}
    </div>
  );
};

export default ResizeObserverWrapper;